﻿import {JSX, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import {HtmlControlProps} from "./HtmlControlProps";

// "horizontal-aligned" reserves the label-row height above the switch so it
// top-aligns with sibling labeled controls when placed side by side in a grid.
export type SwitchLayout = "horizontal" | "vertical" | "horizontal-aligned";

export interface SwitchProps extends Omit<HtmlControlProps<HTMLInputElement>, "value"> {
	checked?: boolean;
	layout?: SwitchLayout;
}

export default function Switch(props: SwitchProps): JSX.Element {
	const {
		label,
		name,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		ref,
		checked,
		layout
	} = props;
	const controlId = useControlId(id);

	const klass = useMemo(() => `labelled-field switch--${layout ?? "horizontal"}${column ? ` ${column}` : ""}`, [column, layout]);

	if (hidden) {
		return <></>;
	}

	return <div className={klass}>
		<div className="form__field form__field--switch">
			<input type="checkbox"
			       role="switch"
			       ref={ref}
			       id={controlId}
			       name={name}
			       onChange={onChange}
			       onBlur={onBlur}
			       value={"1"}
			       checked={checked}
			       tabIndex={disabled ? -1 : undefined}
			       readOnly={disabled}
			       disabled={disabled}/>
			<label className="switch__label" htmlFor={controlId} data-off="" data-on="">
				<span className="label__text">{label}</span>
			</label>
		</div>
	</div>;
};
